export default "__VITE_ASSET__BE7bmFs0__"